module.exports = __webpack_public_path__ + "static/OP10-703349047a40bab6252b36cf04d837b8.gif";